import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './core/guards/auth/auth.guard';
import { ClientDataGuard } from './core/guards/client/client-data.guard';
import { IncapacitatedGuard } from './core/guards/incapacitated/incapacitated.guard';
import { InitStateGuard } from './core/guards/init-state/init-state.guard';

export const giftingRoutes: Routes = [
  {
    path: 'gifting',
    children: [
      {
        path: 'overview', // setting us up to change on public site
        loadChildren: () =>
          import('./public/gifting-overview/gifting-overview.module').then(
            (m) => m.GiftingOverviewModule,
          ),
      },
      {
        path: 'triage',
        loadChildren: () =>
          import('./public/gifting-triage/gifting-triage.module').then(
            (m) => m.GiftingTriageModule,
          ),
      },
      {
        path: 'summary',
        loadChildren: () =>
          import('./public/gifting-summary/gifting-summary.module').then(
            (m) => m.GiftingSummaryModule,
          ),
      },
    ],
  },
  {
    path: 'secure/gifting',
    canActivate: [AuthGuard, ClientDataGuard, InitStateGuard, IncapacitatedGuard],
    children: [
      // gifting secure pages
      {
        path: 'assets',
        loadChildren: () =>
          import('./secure/gifting-assets/gifting-assets.module').then(
            (m) => m.GiftingAssetsModule,
          ),
      },
      {
        path: 'method/:position_id',
        loadChildren: () =>
          import('./secure/gifting-method/gifting-method.module').then(
            (m) => m.GiftingMethodModule,
          ),
      },
      {
        path: 'additional-instructions',
        loadChildren: () =>
          import(
            './secure/gifting-advised-additional-instructions/gifting-advised-additional-instructions.module'
          ).then((m) => m.GiftingAdvisedAdditionalInstructionsModule),
      },
      {
        path: 'recipient',
        loadChildren: () =>
          import('./secure/gifting-recipient/gifting-recipient.module').then(
            (m) => m.GiftingRecipientModule,
          ),
      },
      {
        path: 'recipient-triage',
        loadChildren: () =>
          import('./secure/gifting-recipient-triage/gifting-recipient-triage.module').then(
            (m) => m.GiftingRecipientTriageModule,
          ),
      },
      {
        path: 'intelledox-redirect',
        loadChildren: () =>
          import('./secure/gifting-intelledox-redirect/gifting-intelledox-redirect.module').then(
            (m) => m.GiftingIntelledoxRedirectModule,
          ),
      },
      {
        path: 'terms',
        loadChildren: () => import('./secure/terms/terms.module').then((m) => m.TermsModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(giftingRoutes)],
  exports: [RouterModule],
})
export class GiftingRoutingModule {}
